import { COU_httpGet, COU_httpPost } from '@/utils/http'
import { COU_Sleep } from "@/utils/co_util"

// 获取淘特类目列表
async function GetCategoryList(data) {
  const r = await COU_httpGet({ url: '/taote/cats', data })
  let list = [], success = false, msg = ''
  try {
    success = r.success
    list = success ? r.result : []
    msg = r.result
  }
  catch(error) {
    console.log(error)
  }
  list = list || []
  return { list, success, msg }
}

// 获取淘特商品池选项列表
async function GetPoolList() {
  const r = await COU_httpGet({ url: 'taote/pools' })
  let pools = []
  try {
    if (r.success) pools = r.result
  }
  catch(error) {
    console.log(error)
  }
  pools = pools || []
  return { pools }
}

// 淘特搜词
async function SearchGoodsByKeyword(data) {
  // 分页器是从1开始(写0就不高亮了)，接口参数是从0开始，所以每次需要减1再传
  data.page--
  data.catId = data.catId?.length ? data.catId[data.catId.length - 1] : ''
  const url = '/taote/productList'
  const r = await COU_httpGet({ url, data })
  let list = [], msg = '', success = false, total = 0, info = {}
  try {
    success = r.success
    msg = r.msg
    if (!success) info = r.result
    list = r.result.Datas
    total = r.result.TotalNum
  } 
  catch (error) {
    console.log(error)
  }
  if (!list?.length) {
    list = []
    // 如果第一次没有获取到数据，那就再请求一次
    if (!data.isLastGetApi) {
      data.isLastGetApi = true
      data.page+=1
      await COU_Sleep(800)
      return SearchGoodsByKeyword(data)
    }
  }
  list = list || []
  if (msg?.includes('查询淘特商品失败')) msg = '查询淘特商品失败，请点击【搜索】按钮或者刷新页面后再试'
  return { list, msg, success, total, info }
}

// 淘特精选货盘
async function SearchGoodsByJx(data) {
  const params = {
    page: data.page, size: data.size,
    title: data.keyword, trade: data.poolId, 
    order_by: data.sort || '-CreateTime',
    firstCid: data.catId
  }
  const url = '/taote/searchTtJxItemList'
  const r = await COU_httpPost({ url, data: params })
  let list = [], msg = '', success = false, total = 0, info = {}
  try {
    success = r.success
    msg = r.msg
    if (!success) info = r.result
    list = r.result.Datas
    total = r.result.TotalNum
  } 
  catch (error) {
    console.log(error)
  }
  list = list || []
  return { list, msg, success, total, info }
}

// 淘特搜图
async function SearchGoodsByImage(data) {
  const url = `/taote/imageSearchItemList`
  const r = await COU_httpPost({ url, data })
  let list = [], total = 0, msg = '', success = false, info = {}
  try {
    msg = r.msg
    success = r.success
    if (!success) {
      info = r.result
      msg = info?.Code ? '目前需要先授权淘特，才能正常使用选品功能' : msg
    }
    else list = r.result
  } 
  catch (error) {
    console.log(error)
  }
  list = list || []
  total = list.length
  return { list, total, msg, success, info  }
}

export default {
  GetCategoryList, GetPoolList, SearchGoodsByKeyword,
  SearchGoodsByJx, SearchGoodsByImage
}